import React, { useEffect } from 'react';
import { X } from 'react-feather';
import { Modal } from 'react-bootstrap';
import { useViewMode } from 'hooks/index';
import { browserName, browserVersion } from 'react-device-detect';
import { getColor, getColorText } from 'store/settings';
import { useSelector } from 'react-redux';
import { Alert } from 'antd';

const ZoomLink = (props) => {
  const viewMode = useViewMode();
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);

  const openZoomMeet = (links) => {
    if (links) {
      if (browserName === 'Mobile Safari') {
        window.open(links, '_black');
      } else {
        const link = links;
        const a = document.createElement('a');
        a.setAttribute('href', link);
        a.setAttribute('target', '_blank');
        a.click();
      }
    }
  };

  useEffect(() => {
    if (props.link && props.open === true) {
      openZoomMeet(props.link);
    }
  }, [props.link, props.open]);

  return (
    <div>
      <Modal show={props.open}>
        <Modal.Header style={{ display: 'flow-root' }}>
          <div>
            <span
              style={{ float: 'left', padding: '10px 0px ' }}
              className="card-header-title-label"
            >
              This is a live training event.
            </span>
            <span
              style={{ float: 'right' }}
              className="btn btn-large"
              color="secondary"
              onClick={props.toggle}
            >
              <X style={{ marginLeft: 10 }} />
            </span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Alert
            description={
              <>
                If your Zoom app pop up is not working, it may be due to your
                browser blocking pop ups. Please check your browser settings.
                Alternatively, you can click{' '}
                <a
                  href={props.link}
                  style={{
                    textAlign: 'center',
                    textDecoration: 'underline',
                  }}
                  className="font-weight-bold"
                >
                  <span
                    style={{
                      color: `${colorStatus}`,
                      textDecorationColor: `${colorStatus}`,
                    }}
                  >
                    here
                  </span>
                </a>{' '}
                to load Zoom in this tab
              </>
            }
            type="info"
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn-bg-color"
            onClick={props.toggle}
            style={{
              backgroundColor: `${colorStatus}`,
              color: `${colorTextStatus}`,
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.borderColor = colorStatus;
              e.target.style.color = colorStatus;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = colorStatus;
              e.target.style.color = colorTextStatus;
            }}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ZoomLink;
